// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  candidateId: __t.u64().primaryKey().name("candidate_id"),
  orgId: __t.u64().name("org_id"),
  captainIdentity: __t.string().name("captain_identity"),
  cardJson: __t.string().name("card_json"),
  parentCandidateId: __t.u64().name("parent_candidate_id"),
  axisModifier: __t.string().name("axis_modifier"),
  createdAt: __t.i64().name("created_at"),
});
